import React from 'react';
import Card from 'react-bootstrap/Card';

import CardArranger from './CardArranger';
import { useTranslation } from 'react-i18next';


function renderEntry(res, t) {
    let url = "/?entryID="+res._id;
    return <Card className="h-100">
                            <Card.Body>
                                <Card.Title><a href={url}>{res.title}</a></Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">{res.institution}</Card.Subtitle>
                                <Card.Subtitle className="mb-2 text-muted">{t("consumer") + " - " + res.client_type}</Card.Subtitle>
                                <Card.Text>{res.desc}</Card.Text>
                            </Card.Body>

                            <Card.Footer className="text-muted">

                                {res.url &&
                                    <Card.Link href={res.url}>{t("webpage")}</Card.Link>
                                }
                                {res.email &&
                                    <Card.Link href={"mailto:" + res.email}>{t("contact")}</Card.Link>
                                }
                            </Card.Footer>
                        </Card>
}


function SearchResults(props) {
    const { t } = useTranslation();
    return <CardArranger render={(res) => renderEntry(res, t)} 
                         results={props.results} 
                         columns={3}>
                    
            </CardArranger>
 
}


export {SearchResults, renderEntry}